"use client";

import { assert } from "../../../../Helpers/logging";

export const assertIsCustomEvent = (event: CustomEvent) => {
    assert(!!event.detail, 'event does not appear to be of type CustomEvent');
};

